import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";
interface DependentsProps {
  data?: any
}

const DependentsView: React.FC<DependentsProps> = ({ data }) => {
  return (
    <div className="container mt-4">
      <div className="row">
        <ReadonlyField label="Number of dependents" value={`${data?.totalDependents || 0}`} />
      </div>
    </div>
  );
};

export default memo(DependentsView);